<template>
	<b-card>
		<div class="hidden-print">
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col>
					<b-form-select
						v-model="departmentId"
						name="departmentId"
					>
						<option v-for="(selectOption, indexOpt) in departments"
								:key="indexOpt"
								:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null" disabled>
								-- {{ $t('priceControl.departments') }} --
							</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col>
					<date-picker
						v-model="fromDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.fromDate')"
						valueType="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col>
					<date-picker
						v-model="toDate"
						lang="ru"
						style="width: 100%"
						:placeholder="$t('certificate.toDate')"
						value-type="format"
						format="DD-MM-YYYY"/>
				</b-col>
				<b-col cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-3" style="width: 40px ;height: 35px;margin-top: -14px"/>
					<b-button @click="print" variant="outline-dark" class="fa fa-print" style="width: 40px ;height: 35px;margin-top: -14px"/>

					<vs-dropdown vs-custom-content vs-trigger-click align="right">
						<b-link href.prevent class="card-header-action btn-setting" style="font-size: 25px;padding: 10px">
							<b-button  class="fa fa-th mr-2" variant="dark" style="padding: 8px;margin-top: -8px;width: 40px ;height: 35px"></b-button>
						</b-link>
						<vs-dropdown-menu class="columns-dropdown">
							<b-checkbox v-model="fields.Starting_balance">{{$t("Starting_balance")}}</b-checkbox>
							<b-checkbox v-model="fields.Income_for_the_period">{{$t("Income_for_the_period")}}</b-checkbox>
							<b-checkbox v-model="fields.Sales_for_the_period">{{$t("Sales_for_the_period")}}</b-checkbox>
							<b-checkbox v-model="fields.Revaluations">{{$t("Revaluations")}}</b-checkbox>
							<b-checkbox v-model="fields.other_expenses">{{$t("other_expenses")}}</b-checkbox>
							<b-checkbox v-model="fields.Balance_at_the_end">{{$t("Balance_at_the_end")}}</b-checkbox>
							<b-checkbox v-model="fields.name">{{ $t('name') }}</b-checkbox>
							<b-checkbox v-model="fields.special_barcode">{{ $t('goods.special-barcode') }}</b-checkbox>
							<b-checkbox v-model="fields.price">{{ $t('incomes.create.price') }}</b-checkbox>
						</vs-dropdown-menu>
					</vs-dropdown>
				</b-col>
			</b-row>
			<hr class="mt-4">
		</div>
		<b-card-body>
			<b-row>
				<b-col cols="3">
					<div style="font-size: 12px">DutyFree International</div>
				</b-col>
				<b-col cols="6" class="text-center">
					<h6><b>{{$t("Turnover_for_the_period")}} {{$t("c")}} {{ fromDate ? fromDate : '________' }} {{$t("po")}} {{ toDate ? toDate : '________' }}</b></h6>
				</b-col>
				<b-col class="text-right"></b-col>
			</b-row>
			<b-row>
				<b-col>
					<b style="font-size: 12px">{{ $t('pricing.department') }}: {{ departmentId ? depName : '__________________' }}</b>
				</b-col>
			</b-row>
			<b-row class="mt-5 mb-4">
				<b-col>
					<table class="b-table table-hover table-striped table-bordered" style="font-size: 11px; width: 100%" id="gridContainer">
						<thead>
						<tr>
							<th colspan="4"></th>
							<th v-if="fields.Starting_balance" class="text-center" style="font-size: 10px" colspan="2">{{$t("Starting_balance")}}</th>
							<th v-if="fields.Income_for_the_period" class="text-center" style="font-size: 10px" colspan="2">{{$t("Income_for_the_period")}}</th>
							<th v-if="fields.Sales_for_the_period" class="text-center" style="font-size: 10px" colspan="2">{{$t("Sales_for_the_period")}}</th>
							<th v-if="fields.Revaluations" class="text-center" style="font-size: 10px" colspan="2">{{$t("Revaluations")}}</th>
							<th v-if="fields.other_expenses" class="text-center" style="font-size: 10px" colspan="2">{{$t("other_expenses")}}</th>
							<th v-if="fields.Balance_at_the_end" class="text-center" style="font-size: 10px" colspan="2">{{$t("Balance_at_the_end")}}</th>
						</tr>
						<tr>
							<th  class="text-center" style="font-size: 10px">№</th>
							<th v-if="fields.name" style="font-size: 10px">{{ $t('name') }}</th>
							<th v-if="fields.special_barcode" class="text-center" style="font-size: 10px">{{ $t('goods.special-barcode') }}</th>
							<th v-if="fields.price" class="text-center" style="font-size: 10px">{{ $t('incomes.create.price') }}</th>
							<th v-if="fields.Starting_balance" class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th v-if="fields.Starting_balance" class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th v-if="fields.Income_for_the_period" class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th v-if="fields.Income_for_the_period" class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th v-if="fields.Sales_for_the_period" class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th v-if="fields.Sales_for_the_period" class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th v-if="fields.Revaluations" class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th v-if="fields.Revaluations" class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th v-if="fields.other_expenses" class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th v-if="fields.other_expenses" class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
							<th v-if="fields.Balance_at_the_end" class="text-center" style="font-size: 10px">{{ $t('sale.kol-vo') }}</th>
							<th v-if="fields.Balance_at_the_end" class="text-center" style="font-size: 10px">{{ $t('pos.sum') }}</th>
						</tr>
						</thead>
						<tbody v-if="!loading">
						<tr v-for="(item, index) in items" :key="`report3-${index}`">
							<td class="text-center">{{ index + 1 }}</td>
							<td v-if="fields.name" class="text-left">{{ item.itemName }}</td>
							<td v-if="fields.special_barcode" class="text-center">{{ item.barcode }}</td>
							<td v-if="fields.price" class="text-center">{{ item.price }}</td>
							<td v-if="fields.Starting_balance" class="text-center">{{ item.bremaining }}</td>
							<td v-if="fields.Starting_balance" class="text-center">{{ item.bsumma }}</td>
							<td v-if="fields.Income_for_the_period" class="text-center">{{ item.wcount }}</td>
							<td v-if="fields.Income_for_the_period" class="text-center">{{ item.wsumma }}</td>
							<td v-if="fields.Sales_for_the_period" class="text-center">{{ item.sCount }}</td>
							<td v-if="fields.Sales_for_the_period" class="text-center">{{ item.ssumma }}</td>
							<td v-if="fields.Revaluations" class="text-center">{{ item.premaining }}</td>
							<td v-if="fields.Revaluations" class="text-center">{{ item.psumma }}</td>
							<td v-if="fields.other_expenses" class="text-center">{{ item.spcount }}</td>
							<td v-if="fields.other_expenses" class="text-center">{{ item.spsumma }}</td>
							<td v-if="fields.Balance_at_the_end" class="text-center">{{ item.blremaining }}</td>
							<td v-if="fields.Balance_at_the_end" class="text-center">{{ item.blsumma }}</td>
						</tr>
						</tbody>
						<tbody v-else>
						<tr>
							<td class="text-center" colspan="16">
								<b-spinner small class="mr-2"/><strong>Loading...</strong>
							</td>
						</tr>
						</tbody>
					</table>
					<b-button v-if="items.length > 0" class="float-right mt-1 hidden-print" @click="excelExport1('gridContainer', 'Отчет № 30')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
				</b-col>

			</b-row>
		</b-card-body>

	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";

export default {
	name: "Товарооборот за период",
	components: {Multiselect},
	data() {
		return {
			fields:{
				Starting_balance:true,
				Income_for_the_period:true,
				Sales_for_the_period:true,
				Revaluations:true,
				other_expenses:true,
				Balance_at_the_end:true,
				name:true,
				special_barcode:true,
				price:true,
			},
			items: {},
			fromDate: null,
			toDate: null,
			departments: [],
			departmentId: null,
			departmentName: '',
			loading: false
		};
	},
	computed: {
		depName() {
			this.departments.forEach(dep => {
				if (dep.id === this.departmentId) {
					this.departmentName = dep.name
				}
			})
			return this.departmentName
		},
		incomesInTermEur() {
			let sum = 0
			this.items.incomesInTerm.forEach(t => {
				sum += t.sumInEur
			})
			return sum
		},
		incomesInTermUzs() {
			let sum = 0
			this.items.incomesInTerm.forEach(t => {
				sum += t.sumInUzs
			})
			return sum
		},
		offsInTermEur() {
			let sum = 0
			this.items.offsInTerm.forEach(t => {
				sum += t.sumInEur
			})
			return sum
		},
		offsInTermUzs() {
			let sum = 0
			this.items.offsInTerm.forEach(t => {
				sum += t.sumInUzs
			})
			return sum
		}
	},
	methods: {
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		print() {
			window.print();
		},
		async getDeps() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		getItems() {
			this.loading = true
			if (this.fromDate && this.toDate && this.departmentId) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					departmentId: this.departmentId
				}
				ReportService.getReportItems3(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: "Выберите Подразделение с периодом",
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	},
	created() {
		this.getDeps();
	},
	watch: {}
}
</script>

<style scoped lang="scss">

@page  {
	margin: 1cm;
}

@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
}

</style>
